import React from 'react';
import ForbiddenContent from 'src/components/forbidden/MainContent';

function Forbidden() {
  return (
    <div className={{ margin: '0px', padding: '0px' }}>
      <ForbiddenContent />
    </div>
  );
}
export default Forbidden;
